import i18next, { type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";
import { extraEn, extraZh } from "./extra";
import type { AppLang } from "./language";

const supportedLngs: AppLang[] = ["zh-CN", "en"];

export const createI18n = (lng: AppLang): I18nInstance => {
  const instance = i18next.createInstance();
  instance.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: "zh-CN",
    supportedLngs,
    interpolation: { escapeValue: false },
  });

  instance.addResourceBundle("zh-CN", "translation", extraZh, true, true);
  instance.addResourceBundle("en", "translation", extraEn, true, true);

  return instance;
};
